import styled from '@emotion/styled';

const dropDown = 'dropdown';
export const dropDownSubListTitle = `${dropDown}__sub_list_title`;
export const dropDownSubListItem = `${dropDown}__sub_list_item`;
export const dropDownListTitle = `${dropDown}__list_title`;

export const StyledDiv = styled.div`
  margin-left: 12px;
  width: 16%;
  max-width: 214px;
  min-width: 134px;

  .${dropDownSubListTitle} {
    font: var(--podium-cds-typography-body2-strong);
    color: var(--podium-cds-color-text-primary);
    font-weight: var(--podium-cds-font-weight-medium);
    padding-top: 36px;
    padding-bottom: 12px;
    &:hover,
    &:focus {
      color: var(--podium-cds-color-text-primary);
    }
  }
  .${dropDownSubListItem} {
    p {
      color: var(--podium-cds-color-text-secondary);
      line-height: 150%;
      padding-bottom: 8px;
      &:hover,
      &:focus {
        color: var(--podium-cds-color-text-primary);
      }
    }
  }
  .${dropDownListTitle} {
    padding-bottom: 12px;
    display: block;
    p {
      font: var(--podium-cds-typography-body1-strong);
      color: var(--podium-cds-color-text-primary);
      font-weight: var(--podium-cds-font-weight-medium);
    }
  }
`;
